import React, { useContext } from "react";
import style from "./style.module.scss";
import { PlanningConstant } from "../../../core/_constant";
import { RiDeleteBin5Line } from "react-icons/ri";
import { InputSelect } from "../../../../../common/components/InputSelect/InputSelect";
import { API_URLs } from "../../../../../utilities/API_URLs";
import {
  capitalizeFirstLetter,
  // getLastElementSplited,
} from "../../../../../utilities/string";
import { MaterialRequestContext } from "../../../core/_context";
import { IoIosAdd } from "react-icons/io";
// import {
//   useQueryChalandForSelect,
//   useQueryTruckForSelect,
// } from "../../../../materials/core/_hooks";
import { OperationContext } from "../CreateOperation";
import { ExportPdf } from "../../../../../common/components/Export/ExportPdf";

enum TYPE_ITEM {
  CHALAND = "BARGE",
  TRUCKER = "TUGBOAT",
}

type EventType = {
  value: any;
  name: string;
  index: number;
  materialType: string;
  type: string;
};

export const MaterialArmingForm = () => {
  const {
    materials,
    onAddMaterialItem,
    onDeleteMaterialItem,
    handleChangeItem,
    selectedMaterials,
    isDisableForm,
  } = useContext(MaterialRequestContext);
  const { initialValue, filter } = useContext(OperationContext);
  const operationId = initialValue?.id;

  // const { data: trucks, isLoading: isLoadingTruck } = useQueryTruckForSelect();
  // const { data: chalands, isLoading: isLoadingChalands } =
  //   useQueryChalandForSelect();

  const handleClickOnAdd = (type: any, materialType: string) => {
    onAddMaterialItem(
      `materials${capitalizeFirstLetter(materialType.toLowerCase())}${type}`
    );
  };

  const handleChange = (event: EventType) => {
    const { materialType, type, index, value, name } = event;
    const keyName = `materials${capitalizeFirstLetter(
      materialType.toLowerCase()
    )}${type}`;

    handleChangeItem(index, keyName, {
      [name]: value,
    });
  };

  const handleClickOndeDelete = (
    type: any,
    materialType: string,
    index: number
  ) => {
    const keyName = `materials${capitalizeFirstLetter(
      materialType.toLowerCase()
    )}${type}`;

    onDeleteMaterialItem(keyName, index);
  };

  return (
    <div className={style.material_request__container}>
      {/* <pre> {JSON.stringify(materials, null, 2)} </pre> */}
      {PlanningConstant.MATERIAL_REQUEST_TYPE?.map((item: any, i: number) => (
        <div className={style.material_request__item_container} key={i}>
          <div className={style.material_request__title_container}>
            <div className={style.material_request__title}>
              <span> {` MATÉRIELS ${item.label} `} </span>
            </div>

            {item.value === PlanningConstant.MATERIAL_REQUEST_COMAMA ? (
              <ExportPdf
                uri={`/api/operations/${initialValue?.id}/ARMING/COMAMA/pdf`}
                params={{
                  materialsCreatedAt: filter?.teamsCreatedAt,
                }}
              />
            ) : (
              ""
            )}
          </div>

          {/* REMORQUEURS  */}

          <div className={style.material_request__arming_content}>
            <div className={style.material_request__arming_item}>
              <div className={style.material_request__arming_title_content}>
                <span> Remorqueurs </span>
              </div>
              <div className={style.material_request__arming_table_container}>
                <table className={style.material_request__table}>
                  <thead>
                    <tr>
                      <th className={style.material_request__label}>
                        Liste de(s) Remorqueurs demandé
                      </th>

                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {materials?.[`materialsTugboat${item.label}`]?.map(
                      (elem: any, key: number) => (
                        <tr>
                          <td>
                            <InputSelect
                              className={style.material_request__select}
                              value={elem?.material}
                              uri={
                                API_URLs.materials.tugboad.getTugboadForSelect
                              }
                              valueOption={{
                                labelKey: "reference",
                                valueKey: "@id",
                              }}
                              disabled={isDisableForm}
                              excludedValue={selectedMaterials}
                              onChange={(value) => {
                                handleChange({
                                  value,
                                  name: "material",
                                  index: key,
                                  type: item?.value as string,
                                  materialType: TYPE_ITEM.TRUCKER,
                                });
                              }}
                              params={{
                                materialFrom: item?.value,
                                excludeOperation: operationId,
                                materialsCreatedAt: filter?.teamsCreatedAt,
                              }}
                            />
                          </td>

                          <td>
                            <RiDeleteBin5Line
                              className={style.material_request__delete_icon}
                              title="Supprimer"
                              onClick={() =>
                                handleClickOndeDelete(
                                  item.value,
                                  TYPE_ITEM.TRUCKER,
                                  key
                                )
                              }
                            />
                            {elem?.error ? (
                              <span className={style.material_request__error}>
                                Ce champ est requis{" "}
                              </span>
                            ) : (
                              ""
                            )}
                          </td>
                        </tr>
                      )
                    )}
                  </tbody>
                </table>

                <button
                  className={style.material_request__add_btn}
                  style={{
                    cursor: isDisableForm ? "not-allowed" : "pointer",
                  }}
                  disabled={isDisableForm}
                  onClick={() =>
                    handleClickOnAdd(item.value, TYPE_ITEM.TRUCKER)
                  }
                >
                  <IoIosAdd className={style.material_request__add_icon} />
                  Ajouter
                </button>
              </div>
            </div>
            <div className={style.material_request__arming_item}></div>
          </div>

          {/* CHALANDS */}

          <div className={style.material_request__arming_content}>
            <div className={style.material_request__arming_item}>
              <div className={style.material_request__arming_title_content}>
                <span> Chalands </span>
              </div>
              <div className={style.material_request__arming_table_container}>
                <table className={style.material_request__table}>
                  <thead>
                    <tr>
                      <th className={style.material_request__label}>
                        Liste de(s) Chalands demandé
                      </th>

                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {materials?.[`materialsBarge${item.label}`]?.map(
                      (elem: any, key: number) => (
                        <tr>
                          <td>
                            {" "}
                            <InputSelect
                              className={style.material_request__select}
                              value={elem?.material}
                              uri={API_URLs.materials.chaland.getBargeForSelect}
                              valueOption={{
                                labelKey: "reference",
                                valueKey: "@id",
                              }}
                              disabled={isDisableForm}
                              onChange={(value) => {
                                handleChange({
                                  value,
                                  name: "material",
                                  index: key,
                                  type: item?.value as string,
                                  materialType: TYPE_ITEM.CHALAND,
                                });
                              }}
                              params={{
                                materialFrom: item?.value,
                                excludeOperation: operationId,
                                materialsCreatedAt: filter?.teamsCreatedAt,
                              }}
                            />
                            {elem?.error ? (
                              <span className={style.material_request__error}>
                                Ce champ est requis{" "}
                              </span>
                            ) : (
                              ""
                            )}
                          </td>

                          <td>
                            {!isDisableForm ? (
                              <RiDeleteBin5Line
                                className={style.material_request__delete_icon}
                                title="Supprimer"
                                onClick={() =>
                                  handleClickOndeDelete(
                                    item.value,
                                    TYPE_ITEM.CHALAND,
                                    key
                                  )
                                }
                              />
                            ) : (
                              ""
                            )}
                          </td>
                        </tr>
                      )
                    )}
                  </tbody>
                </table>

                <button
                  className={style.material_request__add_btn}
                  disabled={isDisableForm}
                  style={{
                    cursor: isDisableForm ? "not-allowed" : "pointer",
                  }}
                  onClick={() =>
                    handleClickOnAdd(item.value, TYPE_ITEM.CHALAND)
                  }
                >
                  <IoIosAdd className={style.material_request__add_icon} />
                  Ajouter
                </button>
              </div>
            </div>
            <div className={style.material_request__arming_item}></div>
          </div>
        </div>
      ))}
    </div>
  );
};
